import { render, staticRenderFns } from "./TableForm17.vue?vue&type=template&id=42a80658&scoped=true"
import script from "./TableForm17.vue?vue&type=script&lang=ts"
export * from "./TableForm17.vue?vue&type=script&lang=ts"
import style0 from "./TableForm17.vue?vue&type=style&index=0&id=42a80658&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a80658",
  null
  
)

export default component.exports